import {
  Box,
  IconButton,
  Typography,
  useTheme,
  Popover,
  Button,
  Avatar,
  Divider,
  Card,
} from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SyncRounded } from "@mui/icons-material";

const MemTopbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [LastSynce, setLastSynce] = useState("Calculating");
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const role = localStorage.getItem("role");

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    localStorage.removeItem("token");
    localStorage.removeItem("cmpid");
    localStorage.removeItem("cmpname");
    navigate("/Auth/");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/logout`, {
        token,
      });
    } catch (error) {
      //console.log("your session are expired");
    }
  };

  const handlresetPwd = () => {
    navigate("/Auth/forgot-password");
  };

  const fetchUserData = async () => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/profile/info",
        { role },
        {
          headers: { Authorization: token },
        }
      );

      setUserData(response.data.user[0]);
      const usersData = response.data.user[0];
      localStorage.setItem("VIOrgId", usersData.vtiger_Org_Id);
      localStorage.setItem("VTContacId", usersData.vtiger_Contact_Id);
      localStorage.setItem("Role", usersData.role);
      const userName = usersData
        ? usersData.role === "admin"
          ? `${usersData.admin_FirstName} ${usersData.admin_LastName}`
          : usersData.user_Name
        : "User Name";

      localStorage.setItem("username", userName);
      localStorage.setItem("userEmail", usersData.admin_Email);
    } catch (err) {
      handleLogout();
      //console.log("Error fetching user data");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-popover" : undefined;

  const avatarLetter = userData
    ? userData.role === "admin"
      ? userData.admin_FirstName.charAt(0).toUpperCase()
      : userData.user_Name.charAt(0).toUpperCase()
    : "U";
  const userName = userData
    ? userData.role === "admin"
      ? `${userData.admin_FirstName} ${userData.admin_LastName}`
      : userData.user_Name
    : "User Name";
  const userEmail = userData
    ? userData.role === "admin"
      ? userData.admin_Email
      : userData.user_Email
    : "user@example.com";

  return (
    <Box
      width="100%"
      marginLeft={0}
      display="flex"
      justifyContent="space-between"
      p={0.5}
      backgroundColor={colors.primary[400]}
      boxShadow={"1px 0px 2px rgba(0, 0, 0, 0.5)"}
      position={"fixed"}
      top={0}
      zIndex={1000}
      height="65px"
    >
      {/* Left Side: Logo and Text */}
      <Box display="flex" alignItems="center" gap={{ xs: 0.5, sm: 1 }}>
        {/* Logo Section */}
        <Box
          component="img"
          src="../../assets/infinite.png"
          alt="Shraddha Infinite"
          sx={{
            height: {
              xs: "32px",
              sm: "32px",
              md: "36px",
              lg: "40px",
              xl: "40px",
            },
            width: {
              xs: "45px",
              sm: "45px",
              md: "60px",
              lg: "80px",
              xl: "100px",
            },
          }}
        />

        {/* Text Section */}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: { xs: "25px", sm: "25px", md: "30px" },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "1rem", sm: "1rem", md: "1.2rem" },
              fontWeight: "bold",
              textTransform: "uppercase",
              marginBottom: 0,
              lineHeight: 1,
            }}
          >
            Shraddha
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "0.9rem", sm: "0.9rem", md: "1.1rem" },
              color: "#B09246",
              textTransform: "uppercase",
              marginTop: 0,
              lineHeight: 1,
            }}
          >
            Infinite
          </Typography>
        </Box>
      </Box>

      {/* ICONS */}
      <Box display="flex" alignItems="center" marginRight="30px" gap={1}>
        <Box ml={1}>
          <Button
            size="small"
            variant="contained"
            sx={{
              color: "#F8F4B2",
              backgroundColor: "#000",
              ":hover": { backgroundColor: "#000" },
              borderRadius: "10px",
              fontSize: "0.8rem",
              padding: "4px 8px",
              minWidth: "auto",
            }}
            onClick={() => window.open("https://forms.gle/vYdvWYphZEcWmNmJ8")}
          >
            Survey
          </Button>
        </Box>

        <IconButton
          onClick={colorMode.toggleColorMode}
          aria-label="Toggle Theme"
          size="small"
          sx={{ padding: 0.7 }}
        >
          {theme.palette.mode === "dark" ? (
            <LightModeOutlinedIcon sx={{ fontSize: "20px" }} />
          ) : (
            <DarkModeOutlinedIcon sx={{ fontSize: "20px" }} />
          )}
        </IconButton>

        <Card
          variant="outlined"
          onClick={handleClick}
          sx={{
            p: 0.5,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            zIndex: 1,
            height: "36px",
            minHeight: "auto",
            borderRadius: 3,
            cursor: "pointer",
            gap: 0.5,
          }}
        >
          <IconButton
            aria-label="User Profile"
            size="small"
            sx={{ padding: 0.3 }}
          >
            <PersonOutlinedIcon sx={{ fontSize: "18px" }} />
          </IconButton>

          <Typography
            fontWeight="bold"
            color="#B09246"
            sx={{ fontSize: "0.8rem" }}
          >
            {userData?.role}
          </Typography>
        </Card>
      </Box>

      {/* User Popup */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            backgroundColor: colors.primary[400],
            color: colors.primary[100],
            borderRadius: "10px",
            minWidth: "250px",
          },
        }}
      >
        <Box padding={1.5} textAlign="center">
          {/* Avatar */}
          <Box
            alignItems="center"
            justifyContent="center"
            style={{ padding: "5px", height: "80px" }}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <Avatar
                style={{
                  backgroundColor: "#EFE17C",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#000000",
                  width: 40,
                  height: 40,
                }}
              >
                {avatarLetter}
              </Avatar>
            </Box>
            <Box padding="5px">
              <Typography
                variant="h4"
                style={{ margin: "0", fontSize: "1rem" }}
              >
                {userName}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ margin: "0", fontSize: "0.8rem" }}
              >
                {userEmail}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ margin: "0", fontSize: "0.8rem" }}
              >
                <strong>ISN:</strong>
                {userData?.infiniteSerialNo}
              </Typography>
            </Box>
          </Box>

          <Divider style={{ marginTop: "30px" }} />

          {/* Buttons */}
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="8px"
          >
            <Box display="flex" alignItems="center">
              <SettingsOutlinedIcon
                style={{ color: colors.primary[100], fontSize: "18px" }}
              />
              <Button
                variant="text"
                color="inherit"
                onClick={handlresetPwd}
                sx={{ fontSize: "0.8rem", minWidth: "auto" }}
              >
                Change Password
              </Button>
            </Box>
            <Box display="flex" alignItems="center">
              <ExitToAppIcon
                style={{ color: colors.primary[100], fontSize: "18px" }}
              />
              <Button
                variant="text"
                color="inherit"
                onClick={handleLogout}
                sx={{ fontSize: "0.8rem", minWidth: "auto" }}
              >
                Logout
              </Button>
            </Box>
          </Box>

          <Divider style={{ margin: "12px 0" }} />

          {/* Privacy and policy */}
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ fontSize: "0.7rem" }}
            >
              Privacy Policy | Security Statement
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ marginTop: "4px", fontSize: "0.6rem" }}
            >
              © 2025 - 2.O
            </Typography>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default MemTopbar;
